import React, { useEffect, useState, useCallback, useMemo } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";

import { Link } from "react-router-dom";
import config from "../../../../config/config";
import Loader from "../../../../components/Loader/Loader";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";

const CountInventory = (props) => {
  const token = localStorage.getItem("Token");
  const [loading, setLoading] = useState(false);

  return (
    <>

      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="page-title">
              <h3>Count Inventory</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/items">Items</Link>
                </li>
                <li className="breadcrumb-item active">
                  <Link to="/item-count-invetory">Count Inventory</Link>
                </li>
              </ul>
            </div>
            <div className="col-md-4">
              <div className="d-flex flex-row-reverse">
                <div className="p-2">
                  <Link className="btn btn-success" to="/item-count-invetory">
                    Show Open Counts
                  </Link>
                </div>
                <div className="p-2">
                  <Link className="btn btn-info" to="/new-inventory-count">
                    New Inventory Count
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Card for listing count inventory */}
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <DataTable
                  title="Count Inventory"
                  // columns={filteredColumns}
                  // data={data}
                  // progressPending={loading}
                  pagination
                  paginationServer
                  // paginationTotalRows={totalRows}
                  // paginationDefaultPage={currentPage}
                  // onChangeRowsPerPage={(e) => {
                  //   handlePerRowsChange(1, e);
                  // }}
                  // onChangePage={handlePageChange}
                  highlightOnHover
                  striped
                  responsive
                  paginationRowsPerPageOptions={[10, 25, 50, 100, 500]}
                  fixedHeader
                  // fixedHeaderScrollHeight="70vh"
                  persistTableHead
                  sortServer
                  // onSort={handleSort}
                  selectableRows
                // onSelectedRowsChange={e => { handleSelectedRowsChange(e); }}
                // contextActions={contextActions}
                // onSelectedRowsChange={handleRowSelected}
                // clearSelectedRows={toggleCleared}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CountInventory;
